import React, { useState, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, MenuItem, InputLabel, Select, FormControl } from "@mui/material";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseURL } from "./Constant";
import "./ReleaseNotesUploadFile.css";
const ReleaseNotesUploadFile = ({
  isOpen,
  onClose
}) => {
  const [openAlert, setOpenAlert] = useState(null);
  const [action, setAction] = useState("append");
  const fileInputRef = useRef(null);
  const handleFileUpload = async event => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("action", action);
      try {
        const response = await axios.post(`${baseURL}/releaseNotesUpload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        setOpenAlert("success");
      } catch (error) {
        console.error("Error uploading the file:", error);
        setOpenAlert("error");
      }
    }
  };
  const handleAlertClose = () => {
    setOpenAlert(null);
  };
  return <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Upload Release Notes</DialogTitle>
      <DialogContent>
        <FormControl fullWidth variant="outlined" className="migrated-style-releasenotesuploadfile-bc79e7-1">
          <InputLabel id="action-select-label">Action</InputLabel>
          <Select labelId="action-select-label" value={action} onChange={e => setAction(e.target.value)} label="Action">
            <MenuItem value="append">Append</MenuItem>
            <MenuItem value="replace">Replace</MenuItem>
          </Select>
        </FormControl>
        <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} ref={fileInputRef} className="migrated-style-releasenotesuploadfile-bc79e7-2" />
        <Button variant="contained" color="primary" onClick={() => fileInputRef.current.click()} // Trigger the file input
      className="migrated-style-releasenotesuploadfile-bc79e7-3">
          Choose File
        </Button>
        {openAlert === "success" && <Alert severity="success" onClose={handleAlertClose}>
            Release notes uploaded successfully!
          </Alert>}
        {openAlert === "error" && <Alert severity="error" onClose={handleAlertClose}>
            Failed to upload release notes!
          </Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>;
};
export default ReleaseNotesUploadFile;
